var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_31288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.96704 10.6305C8.91891 10.6947 4.32208 15.3342 2.05977 17.5978C1.69074 17.967 1.26555 18.0955 0.776186 17.9269C-0.0100082 17.654 -0.25068 16.6827 0.294843 16.0567C0.342977 16.0005 0.391111 15.9523 0.439245 15.9041C2.68551 13.6566 7.29036 9.06528 7.37861 8.99304C7.29839 8.92882 2.66145 4.31339 0.399134 2.04982C-0.146389 1.504 -0.130344 0.725392 0.439245 0.259835C0.872454 -0.101372 1.51425 -0.077292 1.94745 0.307996C2.01163 0.364184 2.06779 0.420372 2.12395 0.47656C4.36219 2.71605 8.92693 7.3074 8.96704 7.35556C8.99111 7.36359 13.6922 2.65986 15.9626 0.388265C16.4198 -0.0692651 17.0616 -0.125453 17.535 0.235755C18.0644 0.645123 18.1527 1.36754 17.7435 1.88928C17.6874 1.96153 17.6152 2.02574 17.551 2.09798C15.3047 4.3455 10.6919 8.93685 10.6116 8.99304C10.6999 9.06528 15.3448 13.6968 17.6152 15.9684C18.1206 16.474 18.1206 17.1965 17.6392 17.6781C17.2141 18.0955 16.4439 18.1115 15.9786 17.6379C15.4331 17.0761 14.8715 16.5222 14.318 15.9684C12.5851 14.2426 9.04727 10.7108 8.96704 10.6305Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_31288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.da47b088b93132f4e948af83ca945005.svg";
export { ForwardRef as ReactComponent };